// SVGs para emissao de PDF
import { ReactComponent as Stress } from "../components/emojis/Stress.svg";
import { ReactComponent as Fear } from "../components/emojis/Fear.svg";
import { ReactComponent as Angry } from "../components/emojis/Angry.svg";
import { ReactComponent as Tired } from "../components/emojis/Tired.svg";
import { ReactComponent as Sad } from "../components/emojis/Sad.svg";
import { ReactComponent as Indifference } from "../components/emojis/Indifference.svg";
import { ReactComponent as Surprise } from "../components/emojis/Surprise.svg";
import { ReactComponent as Calm } from "../components/emojis/Calm.svg";
import { ReactComponent as Happy } from "../components/emojis/Happy.svg";
import { ReactComponent as Love } from "../components/emojis/Love.svg";

export const url_api = process.env.REACT_APP_LUMI_API;
export const url_customer_panel = process.env.REACT_APP_LUMI_CUSTOMER_PANEL;
export const email_suporte = process.env.REACT_APP_EMAIL_SUPORT ?? "suporte@lumi.com.br";
export const email_contato = process.env.REACT_APP_EMAIL_CONTACT ?? "contato@lumi.com.br";
export const phoneNumber = process.env.REACT_APP_PHONE_CONTACT ?? "(51) 3029-4987";
export const stripeKey = process.env.REACT_APP_STRIPE_PK;
export const PDF_LOGO_URL = "/images/logo-dark.png";

export const Constants = {
    baseUrl: url_api + "/api/web",
    url_api,
    url_customer_panel,
    url_termos_uso: "/termos-de-uso",
    email_suporte,
    stripeKey,
};

export const EmotionEnum = {
    "ESTRESSE/FRUSTRAÇÃO": 1,
    "MEDO/ANSIEDADE": 2,
    "RAIVA/IRRITAÇÃO": 3,
    "CANSAÇO/ESGOTAMENTO": 4,
    "TRISTEZA/DESÂNIMO": 5,
    "INDIFERENÇA/NEUTRALIDADE": 6,
    "SURPRESA/ESPANTO": 7,
    "CALMA/ALÍVIO": 8,
    "ALEGRIA/SATISFAÇÃO": 9,
    "AMOR/GRATIDÃO": 10,
};

export const EmotionEmojiMap = {
    "ESTRESSE/FRUSTRAÇÃO": { src: "/images/emojis/Stress.svg", alt: "emoji estressado" },
    "MEDO/ANSIEDADE": { src: "/images/emojis/Fear.svg", alt: "emoji ansioso" },
    "RAIVA/IRRITAÇÃO": { src: "/images/emojis/Angry.svg", alt: "emoji com raiva" },
    "CANSAÇO/ESGOTAMENTO": { src: "/images/emojis/Tired.svg", alt: "emoji cansado" },
    "TRISTEZA/DESÂNIMO": { src: "/images/emojis/Sad.svg", alt: "emoji triste" },
    "INDIFERENÇA/NEUTRALIDADE": { src: "/images/emojis/Indifference.svg", alt: "emoji indiferente" },
    "SURPRESA/ESPANTO": { src: "/images/emojis/Surprise.svg", alt: "emoji surpreso" },
    "CALMA/ALÍVIO": { src: "/images/emojis/Calm.svg", alt: "emoji calmo" },
    "ALEGRIA/SATISFAÇÃO": { src: "/images/emojis/Happy.svg", alt: "emoji feliz" },
    "AMOR/GRATIDÃO": { src: "/images/emojis/Love.svg", alt: "emoji amor/gratidão" },
};

export const EmotionEmojiMapForGraph = {
    "ESTRESSE/FRUSTRAÇÃO": Stress,
    "MEDO/ANSIEDADE": Fear,
    "RAIVA/IRRITAÇÃO": Angry,
    "CANSAÇO/ESGOTAMENTO": Tired,
    "TRISTEZA/DESÂNIMO": Sad,
    "INDIFERENÇA/NEUTRALIDADE": Indifference,
    "SURPRESA/ESPANTO": Surprise,
    "CALMA/ALÍVIO": Calm,
    "ALEGRIA/SATISFAÇÃO": Happy,
    "AMOR/GRATIDÃO": Love,
};

export const OnGoingDevMap = {
    IN_PROGRESS: "Em andamento",
    CONCLUDED: "Concluída",
    EXPIRED: "Expirada",
};
